import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { HowItWorks } from './components/HowItWorks';
import { Benefits } from './components/Benefits';
import { Offer } from './components/Offer';
import { SocialProof } from './components/SocialProof';
import { Differentiation } from './components/Differentiation';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-navy overflow-hidden flex flex-col" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <Problem data-id="element-3" />
      <Solution data-id="element-4" />
      <HowItWorks data-id="element-5" />
      <Benefits data-id="element-6" />
      <Offer data-id="element-7" />
      <SocialProof data-id="element-8" />
      <Differentiation data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </main>;
}